(function (jQuery) {
  var product_id = window.app_product_id;
  var app_product_title = window.app_product_title || "";
  var city;
  var fp;
  var capacities = [];
  var pincodes = [];
  var entered_pincode = $(".form-" + product_id + " .app-form-location-opt__input").val() || "";
  var addon_variants = [];
  var pin_validated = false;
  var cart_data = null;
  var cityLocalStorage = localStorage.getItem("city_name");
  var cutoffTimeRunning = false;
  var subscription_product_types = ["Subscription"];

  if ($('body').hasClass('template-product')) {
    var is_subscription_product = window.app_product_tags.includes("subscription");
    // window.app_product_tags is all lower case
    var is_subscription_saturdays = window.app_product_tags.includes("subscription-saturdays");
    var is_subscription_mondays = window.app_product_tags.includes("subscription-mondays");
    var date_picker_id = is_subscription_product ? ' .app-date-subscription' : '#app-date';
    var delivery_date_range = is_subscription_product ? 90 : 90;
  }
  else {
    var is_subscription_product = false;
    // window.app_product_tags is all lower case
    var is_subscription_saturdays = false;
    var is_subscription_mondays = false;
    var date_picker_id = '.app-date-subscription';
    var delivery_date_range = 90;
  }
  var selected_greeting_card = "";
  var date_format_options = {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  };
  var add_to_cart_btn = $(".action-btn.addtocart");
  // add_to_cart_btn.attr("disabled", "true");
  //$(".addtocartqv").attr("disabled", "true");
  window.calculateTotalPrice = function (changedItem) {
    $('#AddToCartForm #prod-cost-block').show();
    updateTotalPrice();
  }
  window.calculateTotalPriceQv = function (changedItem) {
    $('#quickViewModal #prod-cost-block').show();
    updateTotalPriceQv();
  }
  function fetchFromAPI(url, params) {
    var url = new URL(url)
    url.search = new URLSearchParams(params).toString();
    return fetch(url).then(res => res.json());
  }
  async function getCityPincodes(city) {
    //var jsonurl = $('.city-code').val();
    //var jsonurl = $('.city-code').data('defulte-pin');
    //const fetch_url = 'https:' + jsonurl;

    try {
      //const response = await fetch(fetch_url);
      //const data = await response.json();
      //const cityData = data.find(cityObj => cityObj.city === city);
      const cityData = Cityobje.find(cityObj => cityObj.city_name === city);
      console.log('City Data', cityData);
      if (cityData) {
        const pincodes = cityData.zipcodes || [];
        return pincodes;
      } else {
        return [];
      }
    } catch (error) {
      console.error(error);
      return [];
    }
  }
  function changeTimeFormat() {
    let date = new Date();
    let hours = date.getHours();
    let minutes = date.getMinutes();
    // Check whether AM or PM
    let newformat = hours >= 12 ? 'PM' : 'AM';
    // Find current hour in AM-PM Format
    hours = hours % 12;
    // To display "0" as "12"
    hours = hours ? hours : 12;
    minutes = minutes < 10 ? '0' + minutes : minutes;
    return hours + ':' + minutes + ' ' + newformat;
  }

  const convertTime12to24 = (time12h) => {
    const [time, modifier] = time12h.split(' ');

    let [hours, minutes] = time.split(':');

    if (hours === '12') {
      hours = '00';
    }

    if (modifier === 'PM') {
      hours = parseInt(hours, 10) + 12;
    }

    return `${hours}:${minutes}`;
  }
  function standerOrFixeoption(listObj) {
    var temp = "";
    for (var i = 0; i < listObj.length; i++) {
      temp += '<option>' + listObj[i].delivery_time + '</option>';
    }
    return temp;
  }

  function cutoffTime() {
    if (cutoffTimeRunning) return;
    cutoffTimeRunning = true;

    var defulteTime = new Date($.now());
    // var fixeListData = fixeList.split(",");
    var selectedDate = new Date();
    var currentDate = new Date();
    var type_slot = "";
    var selectedDateTemp = new Date().fp_incr(1);
    var formId = "";

    flat_picker_options.minDate = new Date().fp_incr(0);
    if ($('body').hasClass('modal-open')) {
      var timeSlotDropdown = document.querySelector("#quickViewModal .app-time-subscription");
      var tempCity = city.replace(" ", "-");
      //var product_id =  $("#quickViewModal").data('product-id');
      var product_id = window.quickViewProductId;

      var dom_standardListWithCoff = $($.parseHTML($('#ProductMetaTimeStandardTime-' + product_id).html()));
      var dom_fixeListWithCoff = $($.parseHTML($('#ProductMetaTimeFixe-' + product_id).html()));
      var dom_pickDateListWithCoff = $($.parseHTML($('#ProductMetaPickDate-' + product_id).html()));
      var fixeListWithCoffTemp = '';
      var standardListWithCoffTemp = '';
      var pickDateListWithCoffTemp = [];
      for (var i = 0; i < dom_standardListWithCoff.length; i++) {
        if (dom_standardListWithCoff[i].className == tempCity) {
          standardListWithCoffTemp = JSON.parse(dom_standardListWithCoff[i].innerHTML);
        }
      }
      for (var i = 0; i < dom_fixeListWithCoff.length; i++) {
        if (dom_fixeListWithCoff[i].className == tempCity) {
          fixeListWithCoffTemp = JSON.parse(dom_fixeListWithCoff[i].innerHTML);
        }
      }
      for (var i = 0; i < dom_pickDateListWithCoff.length; i++) {
        if (dom_pickDateListWithCoff[i].className == tempCity) {
          pickDateListWithCoffTemp = JSON.parse(dom_pickDateListWithCoff[i].innerHTML);
        }
      }
      var app_product_template = $("#quickViewModal .app-pincode").data('template');
      selectedDateTemp = new Date($("#quickViewModal .app-date-subscription").val());
      type_slot = $("#quickViewModal .slot:checked").val();
      formId = '#quickViewModal';
      pickDateListWithCoffTemp?.forEach((item, index) => {
        const key = `pick_date_${index + 1}`;
        const slotsKey = `pick_date_${index + 1}_slots`;
        if (item[key] != null && item[slotsKey] != null) {
          if (isSameDate(item[key], selectedDateTemp)) {
            fixeListWithCoffTemp = item[slotsKey];
          }
        }
      });
      // fixeListWithCoffTemp = fixeListWithCoffTemp.map(person => ({ cutoff_time: person.cutoff_time.toUpperCase(), delivery_time: person.delivery_time.toUpperCase() }));
      // standardListWithCoffTemp = standardListWithCoffTemp.map(person => ({ cutoff_time: person.cutoff_time.toUpperCase(), delivery_time: person.delivery_time.toUpperCase() }));
      // if (!Array.isArray(fixeListWithCoffTemp) || !fixeListWithCoffTemp.length) fixeListWithCoffTemp = fixeListWithCoff[city] || [];
      // if (!Array.isArray(standardListWithCoffTemp) || !standardListWithCoffTemp.length) standardListWithCoffTemp = standardListWithCoff[city] || [];

      fixeListWithCoffTemp = fixeListWithCoffTemp.map(person => ({ cutoff_time: person.cutoff_time.toUpperCase(), delivery_time: person.delivery_time.toUpperCase() }));
      standardListWithCoffTemp = standardListWithCoffTemp.map(person => ({ cutoff_time: person.cutoff_time.toUpperCase(), delivery_time: person.delivery_time.toUpperCase() }));
    }
    else {
      var app_product_template = $('body').data('template');
      type_slot = $("#AddToCartForm .slot:checked").val();
      selectedDateTemp = new Date($("#AddToCartForm .app-date-subscription").val());
      var timeSlotDropdown = document.querySelector("#AddToCartForm .app-time-subscription");
      formId = '#AddToCartForm';
      var standardListWithCoffTemp = standardListWithCoff[city];
      var fixeListWithCoffTemp = fixeListWithCoff[city];
      var pickDateListWithCoffTemp = pickDateListWithCoff[city];
      pickDateListWithCoffTemp?.forEach((item, index) => {
        const key = `pick_date_${index + 1}`;
        const slotsKey = `pick_date_${index + 1}_slots`;
        if (item[key] != null && item[slotsKey] != null) {
          if (isSameDate(item[key], selectedDateTemp)) {
            fixeListWithCoffTemp = item[slotsKey];
          }
        }
      });
      fixeListWithCoffTemp = fixeListWithCoffTemp.map(person => ({ cutoff_time: person.cutoff_time.toUpperCase(), delivery_time: person.delivery_time.toUpperCase() }));
      standardListWithCoffTemp = standardListWithCoffTemp.map(person => ({ cutoff_time: person.cutoff_time.toUpperCase(), delivery_time: person.delivery_time.toUpperCase() }));
    }

    var selectedDate = $(formId + " .app-date-subscription").val();
    if (selectedDate == '') {
      var currentTime = new Date($.now());
    } else {
      var today = new Date();
      var date = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
      var selectedDateTemp = new Date(selectedDate);
      var SelectDateDay = selectedDateTemp.getFullYear() + '-' + (selectedDateTemp.getMonth() + 1) + '-' + selectedDateTemp.getDate();

      if (date == SelectDateDay) {
        var currentTime = new Date($.now());
      } else {
        var currentTime = new Date(selectedDate);
      }
    }

    var standardArray = []
    for (var n = 0; n < standardListWithCoffTemp.length; n++) {
      var standardTimeInt = convertTime12to24(standardListWithCoffTemp[n].cutoff_time).replace(":", '.')
      standardArray.push({ "key": n, "val": standardTimeInt });
    }
    var nextDayCutoffTimeStanderIndex = Math.max.apply(Math, standardArray.map(function (o) { return o.key; }));
    var tempStanderdVal = Math.max.apply(Math, standardArray.map(function (o) { return o.val; }));
    var tempStanderElemet = standardArray.filter(function (item1) { return item1.val >= tempStanderdVal; }).sort(function (item3, item4) { return item3.val - item4.val; });

    if (tempStanderElemet.length > 0 && tempStanderElemet[0].key) {
      nextDayCutoffTimeStanderIndex = tempStanderElemet[0].key;
    }
    var fixeArray = []
    for (var n = 0; n < fixeListWithCoffTemp.length; n++) {
      var fixeTimeInt = convertTime12to24(fixeListWithCoffTemp[n].cutoff_time).replace(":", '.')
      fixeArray.push({ "key": n, "val": fixeTimeInt });
    }

    var nextDayCutoffTimeFixIndex = Math.max.apply(Math, fixeArray.map(function (o) { return o.key; }));
    var tempFixedVal = Math.max.apply(Math, fixeArray.map(function (o) { return o.val; }));
    var tempElemet = fixeArray.filter(function (item1) { return item1.val >= tempFixedVal; }).sort(function (item3, item4) { return item3.val - item4.val; });

    if (tempElemet.length > 0 && tempElemet[0].key) {
      nextDayCutoffTimeFixIndex = tempElemet[0].key;
    }

    var cutoff_time = new Date(selectedDate);
    var standard_temp = '';
    var fixe_timetemp = '<option value=" ">Select a Time Slot</option>';


    standardNextDay = convertTime12to24(standardListWithCoffTemp[nextDayCutoffTimeStanderIndex].cutoff_time);
    const standardNextDayArr = standardNextDay.split(':');

    fixeNextDay = convertTime12to24(fixeListWithCoffTemp[nextDayCutoffTimeFixIndex].cutoff_time);
    const fixeNextDayArr = fixeNextDay.split(':');

    var nextDayCutoffTimeFix = new Date();
    nextDayCutoffTimeFix.setHours(parseInt(fixeNextDayArr[0]), parseInt(fixeNextDayArr[1]),00);
    var nextDayCutoffTimeStander = new Date();
    nextDayCutoffTimeStander.setHours(parseInt(standardNextDayArr[0]), parseInt(standardNextDayArr[1]),00);

    if (app_product_template == "product.24-hours-buffer") {
      var nextDateTime = new Date($.now());
      nextDateTime.setDate(nextDateTime.getDate() + 1);
      if (nextDateTime.getDate() == currentTime.getDate()) {
        var CurrDayTime = new Date($.now());
        var hrs = CurrDayTime.getHours();
        var min = CurrDayTime.getMinutes();
        //currentTime.setDate(currentTime.getDate() - 1);
        currentTime.setHours(hrs);
        currentTime.setMinutes(min);
      }

      if (defulteTime > nextDayCutoffTimeFix && defulteTime > nextDayCutoffTimeStander) {
        //console.log('--------if---------',);
        $(formId + " #slot-standar").next('label').show();
        $(formId + " #slot-standard").next('label').show();
        $(formId + " #slot-fixe").next('label').show();
        $(formId + " #slot-fix").next('label').show();

        if (type_slot == 'standard') {
          standard_temp += standerOrFixeoption(standardListWithCoffTemp);
          //console.log('--------if---------1',standard_temp);
          $(formId + ' #app-time-subscription').html(standard_temp);
        } else {
          fixe_timetemp += standerOrFixeoption(fixeListWithCoffTemp);
          $(formId + ' #app-time-subscription').html(fixe_timetemp);
        }
        flat_picker_options.minDate = new Date().fp_incr(2);
      } else {

        var standard_count_option = 0;
        for (var i = 0; i < standardListWithCoffTemp.length; i++) {
          CutoffTimeTemp = convertTime12to24(standardListWithCoffTemp[i].cutoff_time);
          const CutoffTimeTempArray = CutoffTimeTemp.split(':');
          cutoff_time.setHours(parseInt(CutoffTimeTempArray[0]), parseInt(CutoffTimeTempArray[1]),00);


          if (currentTime < cutoff_time) {
            standard_count_option++;
            standard_temp += '<option>' + standardListWithCoffTemp[i].delivery_time + '</option>';
          }
        }
        var fixe_count_option = 0;
        for (var i = 0; i < fixeListWithCoffTemp.length; i++) {
          CutoffTimeTemp = convertTime12to24(fixeListWithCoffTemp[i].cutoff_time);
          const CutoffTimeTempArray = CutoffTimeTemp.split(':');
          cutoff_time.setHours(parseInt(CutoffTimeTempArray[0]), parseInt(CutoffTimeTempArray[1]),00);


          if (currentTime < cutoff_time) {
            fixe_count_option++;
            fixe_timetemp += '<option>' + fixeListWithCoffTemp[i].delivery_time + '</option>';
          }
        }
        //console.log('--------else---------2----standard_count_option',standard_count_option);
        //console.log('--------else---------2----fixe_count_option',fixe_count_option);
        if (standard_count_option > 0 && fixe_count_option > 0) {
          $(formId + " #slot-standard").next('label').show();
          $(formId + " #slot-standar").next('label').show();
          $(formId + " #slot-fixe").next('label').show();
        } else if (standard_count_option > 0) {
          $(formId + " #slot-standar").next('label').show();
          $(formId + " #slot-standard").next('label').show();
        } else if (fixe_count_option > 0) {
          $(formId + " #slot-fixe").next('label').show();
        }

        if (standard_count_option == 0) {
          $(formId + " #slot-standar").next('label').hide();
          $(formId + " #slot-standard").next('label').hide();
        }
        if (fixe_count_option == 0) {
          $(formId + " #slot-fixe").next('label').hide();
        }
        if (type_slot == 'standard') {
          if (standard_count_option == 0) {
            $(formId + " #slot-fixe").prop('checked', true);
            $(formId + " #slot-fix").prop('checked', true);
            $(formId + " .slot").trigger('change');
            $(formId + ' #app-time-subscription').html(fixe_timetemp);
          } else {
            $(formId + ' #app-time-subscription').html(standard_temp);
          }
        } else {
          if (fixe_count_option == 0) {
            $(formId + " #slot-standard").prop('checked', true);
            $(formId + " #slot-standar").prop('checked', true);
            $(formId + " .slot").trigger('change');
            $(formId + ' #app-time-subscription').html(standard_temp);
          } else {
            $(formId + ' #app-time-subscription').html(fixe_timetemp);
          }
        }
        flat_picker_options.minDate = new Date().fp_incr(1);
      }
    } else {
      if (app_product_template == 'product.subscription') {
        type_slot = 'fixed';
      }
      if (app_product_template == 'product.subscription' && currentTime > nextDayCutoffTimeFix) {
        $(formId + " #slot-fixe").next('label').show();
        flat_picker_options.minDate = new Date().fp_incr(1);
        fixe_timetemp += standerOrFixeoption(fixeListWithCoffTemp);
        $(formId + ' #app-time-subscription').html(fixe_timetemp);
      } else if (defulteTime > nextDayCutoffTimeFix && defulteTime > nextDayCutoffTimeStander) {
        //console.log(new Date().fp_incr(1))
        //console.log('0001 defulteTime',defulteTime);
        //console.log('0001 nextDayCutoffTimeFix',nextDayCutoffTimeFix);
        //console.log('0001 nextDayCutoffTimeStander',nextDayCutoffTimeStander);

        $(formId + " #slot-standar").next('label').show();
        $(formId + " #slot-standard").next('label').show();
        $(formId + " #slot-fixe").next('label').show();
        $(formId + " #slot-fix").next('label').show();

        if (type_slot == 'standard') {
          $(formId + " #slot-standard").next('label').show();
          $(formId + " #slot-standar").next('label').show();
          flat_picker_options.minDate = new Date().fp_incr(1);
          standard_temp += standerOrFixeoption(standardListWithCoffTemp);
          $(formId + ' #app-time-subscription').html(standard_temp);
        } else {
          $(formId + " #slot-fixe").next('label').show();
          flat_picker_options.minDate = new Date().fp_incr(1);
          fixe_timetemp += standerOrFixeoption(fixeListWithCoffTemp);
          $(formId + ' #app-time-subscription').html(fixe_timetemp);
        }
      } else {
        var standard_count_option = 0;
        for (var i = 0; i < standardListWithCoffTemp.length; i++) {
          CutoffTimeTemp = convertTime12to24(standardListWithCoffTemp[i].cutoff_time);
          const CutoffTimeTempArray = CutoffTimeTemp.split(':');

          cutoff_time.setHours(parseInt(CutoffTimeTempArray[0]), parseInt(CutoffTimeTempArray[1]),00);
          if (currentTime < cutoff_time) {
            standard_count_option++;
            standard_temp += '<option>' + standardListWithCoffTemp[i].delivery_time + '</option>';
          }
        }
        var fixe_count_option = 0;
        for (var i = 0; i < fixeListWithCoffTemp.length; i++) {
          CutoffTimeTemp = convertTime12to24(fixeListWithCoffTemp[i].cutoff_time);
          const CutoffTimeTempArray = CutoffTimeTemp.split(':');
          cutoff_time.setHours(parseInt(CutoffTimeTempArray[0]), parseInt(CutoffTimeTempArray[1]),00);
          if (currentTime < cutoff_time) {
            fixe_count_option++;
            fixe_timetemp += '<option>' + fixeListWithCoffTemp[i].delivery_time + '</option>';
          }
        }
        //console.log('0002 standard_temp count_option',standard_count_option);
        //console.log('0002 fixe_timetemp count_option',fixe_count_option);
        if (standard_count_option > 0 && fixe_count_option > 0) {
          $(formId + " #slot-standard").next('label').show();
          $(formId + " #slot-standar").next('label').show();
          $(formId + " #slot-fixe").next('label').show();
        } else if (standard_count_option > 0) {
          $(formId + " #slot-standar").next('label').show();
          $(formId + " #slot-standard").next('label').show();
        } else if (fixe_count_option > 0) {
          $(formId + " #slot-fixe").next('label').show();
        }

        if (standard_count_option == 0) {
          $(formId + " #slot-standar").next('label').hide();
          $(formId + " #slot-standard").next('label').hide();
        }
        if (fixe_count_option == 0) {
          $(formId + " #slot-fixe").next('label').hide();
        }

        if (type_slot == 'standard') {
          if (standard_count_option == 0) {
            $(formId + " #slot-fixe").prop('checked', true);
            $(formId + " #slot-fix").prop('checked', true);
            $(formId + " .slot").trigger('change');
            $(formId + ' #app-time-subscription').html(fixe_timetemp);
          } else {
            $(formId + ' #app-time-subscription').html(standard_temp);
          }
        }
        else {
          if (fixe_count_option == 0) {
            $(formId + " #slot-standard").prop('checked', true);
            $(formId + " #slot-standar").prop('checked', true);
            $(formId + " .slot").trigger('change');
            $(formId + ' #app-time-subscription').html(standard_temp);
          } else {
            $(formId + ' #app-time-subscription').html(fixe_timetemp);
          }
        }
        flat_picker_options.minDate = new Date().fp_incr(0);
      }
    }

    toggleTimePicker(formId);
    cutoffTimeRunning = false;
  }


  async function getCapactiyAndInventoryData(product_id) {
    const productTags = $('body').hasClass('modal-open')
      ? (window.quickViewProductTags || [])
      : (window.app_product_tags || []);

    is_subscription_saturdays = productTags.includes("subscription-saturdays");
    is_subscription_mondays = productTags.includes("subscription-mondays");

    // console.log('is_subscription_saturdays',is_subscription_saturdays);
    //console.log('is_subscription_mondays',is_subscription_mondays);
    // console.log('window.app_product_tags',window.app_product_tags);

    let start_date = new Date();
    let end_date = new Date();
    end_date.setDate(end_date.getDate() + delivery_date_range);

    const cityData = getCityObjeForContext(product_id).find(cityObj => cityObj.city_name === city);
    flat_picker_options = {
      altInput: true,
      altFormat: "F j, Y",
      dateFormat: "Y-m-d",
      minDate: "today",
      maxDate: new Date().fp_incr(delivery_date_range),
      disableMobile: "true",
      //disable: cityData.date_disabled; //hd added by multiple date disabled

    }

    if ($('body').hasClass('modal-open')) {
      var app_product_template = $("#quickViewModal .app-pincode").data('template');
    } else {
      var app_product_template = $('body').data('template');
    }
    if ($('body').hasClass('modal-open')) {
      var timeSlotDropdown = document.querySelector("#quickViewModal .app-time-subscription");
      var tempCity = city.replace(" ", "-");
      //var product_id =  $(".add-item-qv").data('product-id');

      var dom_standardListWithCoff = $($.parseHTML($('#ProductMetaTimeStandardTime-' + product_id).html()));
      var dom_fixeListWithCoff = $($.parseHTML($('#ProductMetaTimeFixe-' + product_id).html()));
      var dom_pickDateListWithCoff = $($.parseHTML($('#ProductMetaPickDate-' + product_id).html()));
      var fixeListWithCoffTemp = '';
      var standardListWithCoffTemp = '';
      var pickDateListWithCoffTemp = [];
      for (var i = 0; i < dom_standardListWithCoff.length; i++) {
        if (dom_standardListWithCoff[i].className == tempCity) {
          standardListWithCoffTemp = JSON.parse(dom_standardListWithCoff[i].innerHTML);
        }
      }
      for (var i = 0; i < dom_fixeListWithCoff.length; i++) {
        if (dom_fixeListWithCoff[i].className == tempCity) {
          fixeListWithCoffTemp = JSON.parse(dom_fixeListWithCoff[i].innerHTML);
        }
      }
      for (var i = 0; i < dom_pickDateListWithCoff.length; i++) {
        if (dom_pickDateListWithCoff[i].className == tempCity) {
          pickDateListWithCoffTemp = JSON.parse(dom_pickDateListWithCoff[i].innerHTML);
        }
      }
      var app_product_template = $("#quickViewModal .app-pincode").data('template');
      selectedDateTemp = new Date($("#quickViewModal .app-date-subscription").val());
      type_slot = $("#quickViewModal  .slot:checked").val();
      formId = '#quickViewModal';
      pickDateListWithCoffTemp?.forEach((item, index) => {
        const key = `pick_date_${index + 1}`;
        const slotsKey = `pick_date_${index + 1}_slots`;
        if (item[key] != null && item[slotsKey] != null) {
          if (isSameDate(item[key], selectedDateTemp)) {
            fixeListWithCoffTemp = item[slotsKey];
          }
        }
      });
      // fixeListWithCoffTemp = fixeListWithCoffTemp.map(person => ({ cutoff_time: person.cutoff_time.toUpperCase(), delivery_time: person.delivery_time.toUpperCase() }));
      // standardListWithCoffTemp = standardListWithCoffTemp.map(person => ({ cutoff_time: person.cutoff_time.toUpperCase(), delivery_time: person.delivery_time.toUpperCase() }));
      if (!Array.isArray(fixeListWithCoffTemp) || !fixeListWithCoffTemp.length) fixeListWithCoffTemp = fixeListWithCoff[city] || [];
      if (!Array.isArray(standardListWithCoffTemp) || !standardListWithCoffTemp.length) standardListWithCoffTemp = standardListWithCoff[city] || [];

      fixeListWithCoffTemp = fixeListWithCoffTemp.map(person => ({ cutoff_time: person.cutoff_time.toUpperCase(), delivery_time: person.delivery_time.toUpperCase() }));
      standardListWithCoffTemp = standardListWithCoffTemp.map(person => ({ cutoff_time: person.cutoff_time.toUpperCase(), delivery_time: person.delivery_time.toUpperCase() }));
    }
    else {
      var app_product_template = $('body').data('template');
      type_slot = $("#AddToCartForm .slot:checked").val();
      selectedDateTemp = new Date($("#AddToCartForm .app-date-subscription").val());
      var timeSlotDropdown = document.querySelector("#AddToCartForm .app-time-subscription");
      formId = '#AddToCartForm';
      var standardListWithCoffTemp = standardListWithCoff[city];
      var fixeListWithCoffTemp = fixeListWithCoff[city];
      var pickDateListWithCoffTemp = pickDateListWithCoff[city];
      pickDateListWithCoffTemp?.forEach((item, index) => {
        const key = `pick_date_${index + 1}`;
        const slotsKey = `pick_date_${index + 1}_slots`;
        if (item[key] != null && item[slotsKey] != null) {
          if (isSameDate(item[key], selectedDateTemp)) {
            fixeListWithCoffTemp = item[slotsKey];
          }
        }
      });
      fixeListWithCoffTemp = fixeListWithCoffTemp.map(person => ({ cutoff_time: person.cutoff_time.toUpperCase(), delivery_time: person.delivery_time.toUpperCase() }));
      standardListWithCoffTemp = standardListWithCoffTemp.map(person => ({ cutoff_time: person.cutoff_time.toUpperCase(), delivery_time: person.delivery_time.toUpperCase() }));
    }
    var standardArray = []
    for (var n = 0; n < standardListWithCoffTemp.length; n++) {
      var standardTimeInt = convertTime12to24(standardListWithCoffTemp[n].cutoff_time).replace(":", '.')
      standardArray.push({ "key": n, "val": standardTimeInt });
    }
    var fixeArray = []
    for (var n = 0; n < fixeListWithCoffTemp.length; n++) {
      var fixeTimeInt = convertTime12to24(fixeListWithCoffTemp[n].cutoff_time).replace(":", '.')
      fixeArray.push({ "key": n, "val": fixeTimeInt });
    }
    var nextDayCutoffTimeStanderIndex = Math.max.apply(Math, standardArray.map(function (o) { return o.key; }));
    var tempStanderdVal = Math.max.apply(Math, standardArray.map(function (o) { return o.val; }));
    var tempStanderElemet = standardArray.filter(function (item1) { return item1.val >= tempStanderdVal; }).sort(function (item3, item4) { return item3.val - item4.val; });

    if (tempStanderElemet.length > 0 && tempStanderElemet[0].key) {
      nextDayCutoffTimeStanderIndex = tempStanderElemet[0].key;
    }
    var nextDayCutoffTimeFixIndex = Math.max.apply(Math, fixeArray.map(function (o) { return o.key; }));
    var tempFixedVal = Math.max.apply(Math, fixeArray.map(function (o) { return o.val; }));
    var tempElemet = fixeArray.filter(function (item1) { return item1.val >= tempFixedVal; }).sort(function (item3, item4) { return item3.val - item4.val; });

    if (tempElemet.length > 0 && tempElemet[0].key) {
      nextDayCutoffTimeFixIndex = tempElemet[0].key;
    }

    standardNextDay = convertTime12to24(standardListWithCoffTemp[nextDayCutoffTimeStanderIndex].cutoff_time);
    const standardNextDayArr = standardNextDay.split(':');

    fixeNextDay = convertTime12to24(fixeListWithCoffTemp[nextDayCutoffTimeFixIndex].cutoff_time);
    const fixeNextDayArr = fixeNextDay.split(':');

    var nextDayCutoffTimeFix = new Date();
    nextDayCutoffTimeFix.setHours(parseInt(fixeNextDayArr[0]), parseInt(fixeNextDayArr[1]),00);
    var nextDayCutoffTimeStander = new Date();
    nextDayCutoffTimeStander.setHours(parseInt(standardNextDayArr[0]), parseInt(standardNextDayArr[1]),00);
    var defulteTime = new Date($.now());

    if (app_product_template == "product.24-hours-buffer") {
      if (defulteTime > nextDayCutoffTimeFix && defulteTime > nextDayCutoffTimeStander) {
        flat_picker_options.minDate = new Date().fp_incr(2);
      } else {
        flat_picker_options.minDate = new Date().fp_incr(1);
      }
    } else {
      if (defulteTime > nextDayCutoffTimeFix && defulteTime > nextDayCutoffTimeStander) {
        flat_picker_options.minDate = new Date().fp_incr(1);
      } else {
        flat_picker_options.minDate = new Date().fp_incr(0);
      }
    }
    if (cityData.date_disabled) {
      console.log('cityData.date_disabled', cityData.date_disabled);
      const selected_date_dd = document.querySelector('.select-data-wrap .select-date-box.select')
      if (selected_date_dd) {
        selected_date_dd.click();
      }
      flat_picker_options.disable = cityData.date_disabled;

    }
    let is_daily_subs_product = false;
    var dateToEnable = is_subscription_mondays ? 1 : 6;


    // subscription date disable logic
    if (window.is_bouquet_of_day && window.is_bouquet_of_day === "true") {
      flat_picker_options.maxDate = new Date().fp_incr(1); // is_bouquet_of_day collection can only be sold today and tomorrow; is_bouquet_of_day is a metafield added to the collection
    } else if (is_subscription_product) {
      var hrs_count = new Date();
      //cutoffTime();


      if (is_subscription_mondays || is_subscription_saturdays) {

        is_daily_subs_product = true;
        flat_picker_options.minDate = new Date().fp_incr(2);

        flat_picker_options['disable'] = [
          function (date) {
            // return true to disable

            return (date.getDay() !== dateToEnable); // enabling saturdays
          }
        ]
      }
    }
    //date_picker_id = '.form_'+product_id+' .app-date-subscription';
    date_picker_id = $('body').hasClass('modal-open') ? '#quickViewModal .app-date-subscription' : '.form_' + product_id + ' .app-date-subscription';
    //if(fp){ fp.destroy();}
    if (fp) {
      if (Array.isArray(fp)) {
        fp.forEach(instance => instance && typeof instance.destroy === 'function' && instance.destroy());
      } else if (typeof fp.destroy === 'function') {
        fp.destroy();
      }
    }

    fp = flatpickr(date_picker_id, flat_picker_options);

    start_date = new Intl.DateTimeFormat('en-US').format(start_date)
    end_date = new Intl.DateTimeFormat('en-US').format(end_date)


    const currentVariantId = jQuery('[name=id]').val()

    var calendar_url = 'https://admin.shadesofspring.in/api/v1/capacity/date-range-calendar'
    var calendar_params = { start_date: start_date, end_date: end_date, city: city }
    var inventory_url = 'https://admin.shadesofspring.in/api/v1/inventory/list/storefront'
    var inventory_params = { start_date: start_date, end_date: end_date, city: city, product_id: Number(product_id), variant_id: Number(currentVariantId) }
    const calendarPromise = fetchFromAPI(calendar_url, calendar_params);
    const inventoryPromise = fetchFromAPI(inventory_url, inventory_params);

    let [calendarData, inventoryData] = await Promise.all([calendarPromise, inventoryPromise]);
    calendarData = Array.isArray(calendarData.data) ? calendarData.data[0] : calendarData.data;
    inventoryData = inventoryData.data || [];
    calendarData = reshapeCalendarData(calendarData, inventoryData)
    capacities = calendarData.capacities || [];

    if (!is_subscription_product) {
      disableDates(start_date, end_date, calendarData.capacities || [])
    } else {
      if (is_daily_subs_product) {
        let firstAvailableDayNum = fp.config.minDate.getDay();
        if (firstAvailableDayNum != dateToEnable) {
          let firstAvailableDate = fp.config.minDate.fp_incr(dateToEnable - firstAvailableDayNum);
          fp.jumpToDate(firstAvailableDate || fp.config.minDate);
          fp.redraw();
        }
      }
    }
    // Auto-select date/time slot after capacity data loads
    const scopeEl = $('body').hasClass('modal-open')
      ? document.querySelector('#quickViewModal')
      : document;
    setupDeliveryDateLabels(scopeEl);

    const lastCutoff = fixeListWithCoffTemp[fixeListWithCoffTemp.length - 1]?.cutoff_time;
    const qvTodayEndDelivery = lastCutoff ? getRemainingTime(lastCutoff.replace(/\s+/g, '')) : '00h 00m';

    autoSelectDeliveryDateTime(scopeEl, qvTodayEndDelivery);

  }
  Date.prototype.addDays = function (days) {
    var date = new Date(this.valueOf());
    date.setDate(date.getDate() + days);
    return date;
  }
  function getDates(startDate, stopDate) {
    startDate = new Date(startDate);
    stopDate = new Date(stopDate);
    var dateArray = [];
    var currentDate = startDate;
    while (currentDate <= stopDate) {
      dateArray.push(new Intl.DateTimeFormat('en-US').format(currentDate));
      currentDate = currentDate.addDays(1);
    }
    return dateArray;
  }

  function disableDates(start_date, end_date, calendarData) {
    const datesToDisable = [];
    const availableDates = [];
    const dateArray = getDates(start_date, end_date);
    const calendarDateObj = {};
    for (let cd of calendarData) {
      if (!cd.available) {
        continue;
      }
      const temp = new Intl.DateTimeFormat('en-US').format(new Date(cd.date));
      calendarDateObj[temp] = 1;
    }
    for (let da of dateArray) {
      let temp = da.split('/');
      let temp2 = `${temp[2]}-${temp[0]}-${temp[1]}`; // '9/30/2021' to 2025-01-30
      if (!calendarDateObj[da]) {
        datesToDisable.push(temp2);
      } else {
        availableDates.push(temp2);
      }
    }

    // if(fp.length > 0){
    //   fp = fp[0];
    // }
    if (fp) {
      fp.config.disable = datesToDisable;
      fp.config.minDate = availableDates[0] || "today";
      fp.jumpToDate(availableDates[0] || "today")
      fp.redraw();
    }
    if (!availableDates.length) {
      updatePincodeHelperText('#pincode-msg-unavailable');
    }
  }
  const reshapeCalendarData = (calendarData, inventoryData) => {
    let inventoryDataObj = {}
    for (let inventory of inventoryData) {
      inventoryDataObj[inventory._id] = inventory.total_inventory - inventory.used_inventory;
    }

    let newSlotGroup = {};
    for (let sg of calendarData.slot_group) {
      newSlotGroup[sg._id] = sg;
    }

    calendarData.slot_group_formatted = newSlotGroup;

    // update capacity info
    const capacities = calendarData.capacities.slice();
    for (let capacity of capacities) {
      let used_capacity_slots = capacity.used_capacity_slots;
      let temp = {};
      for (let t of used_capacity_slots) {
        temp[t.slot_id] = t;
      }

      capacity.available = false;
      let tempDate = new Date(capacity.date);
      capacity.date_string = Intl.DateTimeFormat('en-IN', date_format_options).format(tempDate);

      /**
       * If inventory doesn't exist, capacity shouldn't be used
       */
      if (!inventoryDataObj[capacity.date]) {
        capacity.slots = [];
        continue;
      }
      if (inventoryDataObj[capacity.date] && inventoryDataObj[capacity.date] <= 0) {
        capacity.slots = [];
        continue;
      }

      let slots = calendarData.slot_group_formatted[capacity.slot_group_id].slots.slice();
      for (let i = 0; i < slots.length; i++) {
        const slot = Object.assign({}, slots[i]);
        if (temp[slot._id]) {
          slot.used_capacity = temp[slot._id].used_capacity || 0;
        } else {
          slot.used_capacity = 0;
        }

        /**
         * convert start_time and end_time to numbers from string
         */
        let minutes = 0;
        if (typeof slot.start_time === "string") {
          let slotTemp = slot.start_time.split(':');
          slot.start_time_formatted = Number(slotTemp[0]);
          minutes = Number(slotTemp[1])
        }
        if (typeof slot.end_time === "string") {
          let slotTemp = slot.end_time.split(':');
          slot.end_time_formatted = Number(slotTemp[0]) + (Number(slotTemp[1] || 0) / 60)
        }

        /**
         * set available based on cutoff_hours and used used_capacity
         */
        slot.available = true;
        if (slot.capacity < slot.used_capacity) {
          slot.available = false;
        } else if (!slot.capacity) {
          slot.available = false;
        } else {
          // check for cutoff_hours
          tempDate.setHours(slot.start_time_formatted);
          tempDate.setMinutes(minutes);


          let diff = tempDate - new Date();
          if (diff < slot.cutoff_hours * 60 * 60 * 1000) {
            slot.available = false;
          }
        }

        if (slot.available) {
          capacity.available = true;
        }

        slots[i] = slot;

      }
      capacity.slots = slots;
    }

    delete calendarData.slot_group;
    delete calendarData.slot_group_formatted;
    delete calendarData.slot_groups;
    calendarData.capacities = capacities;
    return calendarData;
  }
  function convert24To12HrFormat(hrs) {
    const temp = hrs.split(':').map(num => Number(num));
    if (temp.length !== 2) {
      return hrs;
    }

    let hr = temp[0];
    let mins = temp[1];
    let am_pm = 'AM';
    if (temp[0] > 12) {
      hr = temp[0] - 12;
    }

    if (temp[0] >= 12) {
      am_pm = 'PM';
    }

    if (mins) {
      return `${hr}:${mins} ${am_pm}`;
    }
    return `${hr} ${am_pm}`;
  }
  function updateCityList() {
    // console.log('=========updateCityList============');
    if (window._all_cities && window._all_cities.length) {
      let city_html = "";
      for (let c of window._all_cities) {
        city_html += `<option value="${c.name}">${c.label}</option>`;
      }
      //  console.log('=========city_html============',city_html);
      jQuery('#city-dropdown').html(city_html);
    }
  }
  function updatePincodeHelperText(product_id) {
    const formSelector = '.form_' + product_id;
    if ($('body').hasClass('modal-open')) {
      var app_product_template = $(".add-item-qv .app-pincode").data('template');
    } else {
      var app_product_template = $('body').data('template');
    }
    if (app_product_template == "product.pan-india") {
      var selectors = ['.pincode-msg-check', '.pincode-msg-available', '.pincode-msg-unavailable'];
    } else {
      var selectors = ['.pincode-msg-check', '.pincode-msg-available', '.pincode-msg-unavailable', '.app-form-group--datepicker', '#app-time-slot', '#app-time-picker', '.app-time-picker', '.delivery-time'];
    }
    if (!$('body').hasClass('template-cart')) {
      for (const selector of selectors) { jQuery(formSelector + ' ' + selector).hide(); }
    }

    if (!entered_pincode) {
      jQuery(formSelector + ' .pincode-msg-check').show();
    } else if (pin_validated) {
      jQuery(formSelector + ' .pincode-msg-check').hide();
      jQuery(formSelector + ' .pincode-msg-available').show();
      $(".form_" + product_id + " input.app-form-location-opt__input").removeClass("error");
      jQuery(formSelector + ' .pincode-msg-unavailable').hide();
      jQuery(formSelector + ' .app-form-group--datepicker:not(.notShow)').show();

      /*if(app_product_template != 'product.subscription' && app_product_template != 'product.pan-india' ){
        //jQuery(formSelector+' #app-time-slot:not(.notShow)').show();
      }
      //jQuery(formSelector+' #app-time-picker:not(.notShow)').show();
      
      if (jQuery(formSelector+' input[name=app-delivery-time]').length && jQuery(formSelector+' input[name=app-delivery-time]').is(":checked")) {
        //jQuery(formSelector+' .app-time-picker').show();
      }*/

      if (app_product_template == "product.pan-india") {
        if ($('body').hasClass('modal-open')) {
          // $('.form_'+product_id+' .addtocartqv:not(.soldoutbtn)').removeAttr("disabled");
        } else {
          // $('.form_'+product_id+' .addtocart:not(.soldoutbtn)').removeAttr("disabled");
        }
      }
    } else if (entered_pincode && !pin_validated) {
      jQuery(formSelector + ' .pincode-msg-unavailable').show();
      $(".form_" + product_id + " input.app-form-location-opt__input").addClass("error");
    } else {
      jQuery(formSelector + ' .pincode-msg-check').show();
    }
    /* }*/
  }
  // Replace this with your actual pin validation logic
  function validatePin(pin) {
    // Your pin validation logic here
    return pin.length === 6; // For example, a valid pin has a length of 6
  }
  async function validateCityPincode(city, value, product_id = '') {
    entered_pincode = value;
    if (!value || value.length !== 6) {
      pin_validated = false;
      $(".form_" + product_id + " input.app-form-location-opt__input").addClass("error");
      // jQuery(add_to_cart_btn).attr("disabled", true);
      // $('.addtocartqv').attr("disabled", "true");
      updatePincodeHelperText(product_id);
      return;
    }
    const pincodes = await getCityPincodes(city);
    if (pincodes.includes(value)) {
      pin_validated = true;
      $(".form_" + product_id + " input.app-form-location-opt__input").removeClass('error');
      getCapactiyAndInventoryData(product_id);
    } else {
      pin_validated = false;
      $(".form_" + product_id + " input.app-form-location-opt__input").addClass("error");
    }
    updatePincodeHelperText(product_id);

  }
  // Event listeners

  if ($('body').hasClass('template-product')) {
    var timeSlotDropdown = document.querySelector('.form_' + product_id + ' .app-time-subscription');
    var selectedOption = $('.form_' + product_id + ' .app-time-subscription').find(":selected").val();
  }
  else {
    var timeSlotDropdown = document.querySelector('.app-time-subscription');
    var selectedOption = $('.app-time-subscription').find(":selected").val();
  }

  jQuery(document).on('change', '.app-date-subscription', function (event) {
    // console.log('test11-app-date-subscription');
    const selected_date = new Date(event.target.value);
    let selectedDatenew = new Date($(this).val());
    let currentDate = new Date();
    var product_id = $(this).closest('form').data('product-id');

    // Remove the time component from the current date for accurate comparison
    var timeSlotDropdown = "";
    var type_slot = "";
    if ($('body').hasClass('modal-open')) {
      var timeVal = $("#quickViewModal .app-time-subscription").val();
      $(' .form_' + product_id + ' .app-date-subscription').removeClass('error');
      timeSlotDropdown = document.querySelector("#quickViewModal .app-time-subscription");
      type_slot = $('#quickViewModal .slot:checked').val();
      $('#quickViewModal .app-date-picker').find('.error').remove();


      if (timeVal != "") {
        //$(' .form_'+product_id+' .addtocartqv').attr("disabled", false); 
        $(' .form_' + product_id + ' .app-time-subscription').removeClass('error');

      } else {
        // $(' .form_'+product_id+' .addtocartqv').attr("disabled", true);
        $(' .form_' + product_id + ' .app-time-subscription').addClass('error');
      }

    } else {
      $(' .form_' + product_id + ' .app-date-subscription').removeClass('error');
      var timeVal = $("#AddToCartForm  .app-time-subscription").val();
      timeSlotDropdown = document.querySelector("#AddToCartForm  .app-time-subscription");
      type_slot = $('#AddToCartForm .slot:checked').val();

      if (timeVal != "") {
        // $(' .form_'+product_id+' .addtocart').attr("disabled",false);
        $(' .form_' + product_id + ' .app-time-subscription').removeClass('error');
      } else {
        //$(' .form_'+product_id+' .addtocart').attr("disabled",true);
        $(' .form_' + product_id + ' .app-time-subscription').addClass('error');
      }
    }
    if (timeSlotDropdown) {
      timeSlotDropdown.selectedIndex = 0;
    }
    currentDate.setHours(0, 0, 0, 0);
    if ($('body').hasClass('modal-open')) {
      var app_product_template = $(".add-item-qv .app-pincode").data('template');
    } else {
      var app_product_template = $('body').data('template');
    }

    if (app_product_template != 'product.subscription' && app_product_template != 'product.pan-india') {
      $('.form_' + product_id + ' #app-time-slot:not(.notShow)').show();
    }

    if ($('.form_' + product_id + ' input[name=app-delivery-time]').length && $('.form_' + product_id + ' input[name=app-delivery-time]').is(":checked")) {
      if (product_id != '8326482231616') {
        $('.form_' + product_id + ' .app-time-picker').show();
      }
    }


    if (selectedDatenew.toDateString() === currentDate.toDateString()) {
      //cutoffTime();
      if (product_id != '8326482231616') {
        $('.form_' + product_id + ' .app-time-picker').show();
      }
    } else {
      flat_picker_options.minDate = new Date().fp_incr(0);
      if (product_id != '8326482231616') {
        $('.form_' + product_id + ' .app-time-picker').show();
      }
      //cutoffTime();
    }
    cutoffTime();

    for (let capacity of capacities) {
      const temp = new Intl.DateTimeFormat('en-US').format(new Date(capacity.date));
      if (temp == selected_date) {
        if (is_subscription_product) {
          $('.addtocartqv:not(.soldoutbtn)').removeAttr("disabled"); break;
        } else {
          break;
        }
      }
    }

  });
  jQuery(document).on('change', '.app-time-subscription', function (event) {
    var product_id = $(this).closest('form').data('product-id');
    var selectedOption = $('.form_' + product_id + ' .app-time-subscription').find(":selected").val();
    //console.log('selectedOption',selectedOption);
    if (selectedOption == " ") {
      if ($('body').hasClass('modal-open')) {
        $(' .form_' + product_id + ' .app-time-subscription').addClass('error');
        // $(' .form_'+product_id+' .addtocartqv').attr("disabled", "true")
      } else {
        $(' .form_' + product_id + ' .app-time-subscription').addClass('error');
        // $(' .form_'+product_id+' .addtocart').attr("disabled", "true");
      }
    } else {
      if ($('body').hasClass('modal-open')) {
        $(' .form_' + product_id + ' .app-time-subscription').removeClass('error');
        //$(' .form_'+product_id+' .addtocartqv:not(.soldoutbtn)').removeAttr("disabled");
      } else {
        $(' .form_' + product_id + ' .app-time-subscription').removeClass('error');
        //$(' .form_'+product_id+' .addtocart:not(.soldoutbtn)').removeAttr("disabled");
      }
    }
  });
  jQuery(document).on('keyup', ' .app-pincode', function (event) {
    var product_id = $(this).closest('form').data('product-id');
    if ($('body').hasClass('template-product')) {
    } else {
      is_subscription_product = true;
    }
    let cityEle = $(this).closest('form').find('.app-form-location-opt__city');
    if (!cityEle && $(this).closest('form').find('#selectDeliveryModal')) {
      cityEle = $(this).closest('form').find('#selectDeliveryModal .app-form-location-opt__city');
    }
    city = cityEle.val();
    const value = event.target.value.trim();

    //console.log('city',city);
    //console.log('value',value);
    //console.log('product_id',product_id);
    //validateCityPincode(city, value , product_id);
    let pinCity = getCityByPincode(value, product_id);
    if (pinCity) {
      cityEle.val(pinCity).trigger('change');
      jQuery('.app-date-subscription').val('');
      validateCityPincode(pinCity, value, product_id);

    } else {
      validateCityPincode(city, "", product_id);
    }
    // console.log('pinCity ',pinCity);
  });
  jQuery(document).on('change', 'input[name=app-delivery-time]', function (event) {
    let selectedTimeSlotInput = jQuery('[name=app-delivery-time]:checked');
    if (!(selectedTimeSlotInput && selectedTimeSlotInput.length)) {
      if (!is_subscription_product) {
        alert('Please select a delivery time');
        return;
      }
    } else {
      if ($(this).is(":checked")) {
        $('input[name=app-delivery-time]').removeClass('error');
        //add_to_cart_btn.removeAttr("disabled");
      } else {
        $('input[name=app-delivery-time]').addClass('error');
        //$(add_to_cart_btn).attr("disabled", "true");
      }
    }
  });
  jQuery(document).on('change', '.selected-city:not(.selected-pan-city)', function (event) {
    event.preventDefault();
    var product_id = $(this).closest('form').data('product-id');
    city = $(this).val();
    // jQuery('#app-pincode').val('')
    // jQuery('.app-date-subscription').val('');
    // getCityPincodes(city);
    // validateCityPincode(city,"",product_id);
    let selectDeliveryBtnPdp = document.querySelector(`.select-delivery-btn[data-target="#selectDeliveryModal"] .select-delivery-text`);
    if (selectDeliveryBtnPdp) {
      selectDeliveryBtnPdp.innerText = `Deliver to: ${city} · Change`;
    }
  });
  // document.querySelectorAll('.select-date-box').forEach(item => {
  //   item.addEventListener('click', function () {
  //     // Find parent
  //     const parent = this.closest('#app-date-picker');

  //     // Remove select class from all children
  //     parent.querySelectorAll('.select-date-box').forEach(el => {
  //       el.classList.remove('select');
  //     });

  //     // Add select class to clicked element
  //     this.classList.add('select');
  //     if (this.classList.contains('custom_date_wrap')) {
  //       parent.querySelector('.app-date-picker-input').style.display = 'block';
  //     }else{
  //       parent.querySelector('.app-date-picker-input').style.display = 'none';
  //     }

  //     let currentSelectDate = this.querySelector('div').dataset.date;
  //     if (currentSelectDate) {
  //     const selectedDate = new Date(currentSelectDate);
  //     const today = new Date();

  //     selectedDate.setHours(0, 0, 0, 0); // Remove time part from both dates
  //     today.setHours(0, 0, 0, 0);

  //     if (selectedDate.getTime() !== today.getTime()) {
  //       document.querySelector(`.same-day-delivery`).classList.remove('show');
  //     } else {
  //       document.querySelector(`.same-day-delivery`).classList.add('show');
  //     }

  //       const dateInterval = setInterval(() => {
  //         const dateEle = parent.querySelector('.app-form-group__datepicker-input');

  //         if (dateEle && dateEle._flatpickr) {
  //           clearInterval(dateInterval);

  //           dateEle._flatpickr.setDate(currentSelectDate, true);
  //         }
  //       },500);
  //     }
  //   });
  // });

  document.addEventListener('click', function (e) {
    const item = e.target.closest('.select-date-box');
    if (!item) return;

    const parent = item.closest('#app-date-picker');
    if (!parent) return;

    // Scope "same-day-delivery" lookup to the same modal/form context to avoid
    // grabbing the wrong element when quick view and the underlying page both exist
    const scopeEl = item.closest('#quickViewModal') || document;

    // Remove select class from all siblings
    parent.querySelectorAll('.select-date-box').forEach(el => {
      el.classList.remove('select');
    });

    // Add select class to clicked element
    item.classList.add('select');
    if (item.classList.contains('custom_date_wrap')) {
      parent.querySelector('.app-date-picker-input').style.display = 'block';
    } else {
      parent.querySelector('.app-date-picker-input').style.display = 'none';
    }

    let currentSelectDate = item.querySelector('div').dataset.date;
    if (currentSelectDate) {
      const selectedDate = new Date(currentSelectDate);
      const today = new Date();

      selectedDate.setHours(0, 0, 0, 0);
      today.setHours(0, 0, 0, 0);

      const sameDayEl = scopeEl.querySelector('.same-day-delivery');
      if (sameDayEl) {
        if (selectedDate.getTime() !== today.getTime()) {
          sameDayEl.classList.remove('show');
        } else {
          sameDayEl.classList.add('show');
        }
      }

      const dateInterval = setInterval(() => {
        const dateEle = parent.querySelector('.app-form-group__datepicker-input');

        if (dateEle && dateEle._flatpickr) {
          clearInterval(dateInterval);
          dateEle._flatpickr.setDate(currentSelectDate, true);
          jQuery(dateEle).trigger('change');
        }
      }, 500);
    }
  });


  /* start code multiple city */
  async function validateCityPanPincode(city, value, product_id = '') {
    entered_pincode = value;

    if (!value || value.length !== 6) {
      pin_validated = false;
      $(".form_" + product_id + " input.app-form-location-opt__input").addClass('error');
      // jQuery(add_to_cart_btn).attr("disabled", true);
      // $('.addtocartqv').attr("disabled", "true");
      updatePincodeHelperText(product_id);
      return;
    }

    const pincodes = await getCityPanPincodes(city);
    if (pincodes.includes(value)) {
      pin_validated = true;
      getCapactiyAndInventoryData(product_id);
      console.log('true check');
    } else {
      pin_validated = false;
      console.log('false check');
    }

    updatePincodeHelperText(product_id);
  }
  async function getCityPincodes(city) {
    try {
      const cityList = getCityObjeForContext(product_id); // product_id must be in scope — see note below
      const cityData = getCityObjeForContext(product_id).find(cityObj => cityObj.city_name === city);

      console.log('another one', cityData);
      const pincodeMsg = document.querySelector('.pincode-msg-available');
      if (pincodeMsg) {
        pincodeMsg.textContent = `Delivery available for ${cityData.city_name}`;
      }

      if (cityData) {
        const pincodes = cityData.zipcodes || [];
        return pincodes;
      } else {
        return [];
      }
    } catch (error) {
      console.error(error);
      return [];
    }
  }
  function getCityByPincode(pincode, product_id) {
    pincode = String(pincode).trim();
    const cityList = getCityObjeForContext(product_id);
    for (let item of cityList) {
      if (!item.zipcodes) continue;
      const zipArray = item.zipcodes.split(",").map(z => z.trim());
      if (zipArray.includes(pincode)) {
        return item.city_name;
      }
    }
    return null;
  }
  jQuery(document).on('change', '.selected-city.selected-pan-city', function (event) {
    event.preventDefault();

    city = $(this).val();
    jQuery('#app-pincode').val('')
    getCityPanPincodes(city);
    validateCityPanPincode();
  });
  jQuery(document).on('keyup', ' .app-pan-pincode', function (event) {
    var product_id = $(this).closest('form').data('product-id');
    //city = $('.selected-pan-city').val();
    city = $(this).closest('form').find('.selected-pan-city').val();
    if ($('body').hasClass('template-product')) {
    } else {
      is_subscription_product = true;
    }
    const value = event.target.value.trim();
    validateCityPanPincode(city, value, product_id)
  });
  /* end code multiple city */

  jQuery(document).on('click', '#quickViewModal .addtocart', function (event) {
    event.preventDefault();

    var $btn = jQuery(this);
    var $scope = $btn.closest('#quickViewModal');

    var isValid = true;

    var $pincode = $scope.find('.main-product-form #selectDeliveryModal .app-pincode');
    var $datepicker = $scope.find('.main-product-form #selectDeliveryModal .app-form-group__datepicker-input').last();
    var $timeSlot = $scope.find('.main-product-form #selectDeliveryModal .app-time-subscription');

    $pincode.removeClass('error');
    $datepicker.removeClass('error');
    $timeSlot.removeClass('error');

    if ($pincode.val().trim() === '') {
      $pincode.addClass('error');
      isValid = false;
    }

    if ($datepicker.length > 0 && $datepicker.val().trim() === '') {
      $datepicker.addClass('error');
      isValid = false;
    }

    if ($timeSlot.length > 0 && ($timeSlot.val().trim() === '' || $timeSlot.val() === ' ')) {
      $timeSlot.addClass('error');
      isValid = false;
    }

    if (!isValid) {
      var $firstError = $scope.find('.select-time-slot-btn[data-target="#selectDeliveryModal"]').first();
      $firstError.addClass('error');

      jQuery('html, body').animate({
        scrollTop: $firstError.offset().top - 150
      }, 600);

      return;
    }

    var productId = Number(window.quickViewProductId);

    var editingItem = window.quickViewCartItemData;

    if (editingItem && editingItem.key) {
      $.ajax({
        type: 'GET',
        url: '/cart.js',
        dataType: 'json',
        success: function (cart) {
          var updates = {};

          // Remove the main item being edited
          updates[editingItem.key] = 0;

          // Find and remove any addon items whose _parent_vid matches this item's id (variant id)
          cart.items.forEach(function (cartItem) {
            var parentVid = cartItem.properties && cartItem.properties._parent_vid;
            if (parentVid && String(parentVid) === String(editingItem.id)) {
              updates[cartItem.key] = 0;
            }
          });

          $.ajax({
            type: 'POST',
            url: '/cart/update.js',
            data: { updates: updates },
            dataType: 'json',
            success: function () {
              Shopify.addItemFromFormStartNew('AddToCartForm-editpopup', productId);
            },
            error: function (err) {
              console.error('Failed to remove main item + addons from cart', err);
            }
          });
        },
        error: function (err) {
          console.error('Failed to fetch cart for addon cleanup', err);
        }
      });
    }
    else {
      Shopify.addItemFromFormStartNew('AddToCartForm-qv', productId);
    }

    $('#quickViewModal').modal('hide');
  });



  jQuery(document).on('click', 'button.btn.modal-action-btn', function (event) {
    event.preventDefault();
    $('.app-form-opts.app-form-opts--addons.selected-addon').html('')
    let addonTemplate = ``
    if (jQuery('[name=app-addons]:checked').length > 0) {
      jQuery('[name=app-addons]:checked').each(function () {
        addonTemplate += `<div class="app-form-opt addon-wrapper-div">
        <div class="app-form-opt__label app-form-opt__label--addons active">
        ${$(this).siblings('.app-form-opt__label').html()
          }</div></div>`
      })
    }
    $('#selected-addons').html(addonTemplate);
    let giftcardElem = jQuery('[name=app-giftcard]:checked')
    let giftcardTemplate = ``
    if (giftcardElem.length > 0) {
      giftcardTemplate += `<div class="app-form-opt__label app-form-opt__label--addons">
      ${giftcardElem.siblings('.app-form-opt__label').html()}
      </div>`
    }
    $('#selected-giftcard').html(giftcardTemplate)
    let messageElem = jQuery('#pers-message').val()

    if (messageElem.length > 0) {
      $('#selected-message').html($('#pers-message').val())
    }
  });
  // End Event listeners
  async function onReadyfn() {
    let localstoragePincode = localStorage.getItem("city_pincode") /*hd uncomment 9-11-2023*/
    city = $('.selected-city').val();
    if (city) {
      let cityresult = await getCityPincodes(city);
      // pincodeValidation(localstoragePincode)
      validateCityPincode(city, localstoragePincode)
    }
  }
  function variantChangeListener() {
    document.querySelectorAll('.variant-input input').forEach(el => {
      el.addEventListener("change", function (event) {
        setTimeout(function () {
          window.location.reload();
        }, 500);
      });
    })
  }
  function checkUncheckGreetingCards() {
    jQuery(".app-form-opt__input--greetingcard").on('click', function (event) {
      if (event.target.checked && event.target.value === selected_greeting_card) {
        event.target.checked = false;
      } else {
        //event.target.checked = false;
      }
      selected_greeting_card = event.target.checked ? event.target.value : "";
    });
  }
  jQuery(document).ready(function () {
    onReadyfn();
    //updateCityList()
    // on change of variant, refresh the page
    if (!is_subscription_product) {
      variantChangeListener();
    }
    checkUncheckGreetingCards();
  });
  // getAddonProducts();
  setTimeout(function () { updatePincodeHelperText(product_id); }, 500);
  function updateTotalPrice() {

    let totalPrice = Number($('#AddToCartForm .current-variant').data('variant_price'));
    totalPrice /= 100;
    let slotPrice = 0;
    if ($('#AddToCartForm .slot:checked').length > 0) {
      slotPrice = Number($('#AddToCartForm  .slot:checked').data('variant_price'));
    }
    let addonPrice = 0;
    jQuery('#AddToCartForm [name=app-addons]:checked').each(function () {
      let addon_price = jQuery(this).data('variant_price') || 0
      //totalPrice += Number(addon_price)/100;
      addonPrice += Number(addon_price) / 100;
    });
    var allExtras = slotPrice + addonPrice;

    var costExtras = jQuery("#AddToCartForm .prod-cost__extras .prod-cost__value");
    var costAddon = jQuery("#AddToCartForm .prod-cost__extras .prod-cost-addon__value");
    var costTotal = jQuery("#AddToCartForm .prod-cost__total .prod-cost__value");
    var addToCartBtnPriceEle = $('#AddToCart .add-to-class-price');

    totalPrice += allExtras;

    totalPrice = totalPrice.toLocaleString(undefined, { minimumFractionDigits: 2 });
    addonPrice = addonPrice.toLocaleString(undefined, { minimumFractionDigits: 2 });
    if (slotPrice > 0) {
      slotPrice = slotPrice.toLocaleString(undefined, { minimumFractionDigits: 2 });
    }

    costExtras.text("Rs." + slotPrice);
    costAddon.text("Rs." + addonPrice);
    costTotal.text("Rs." + totalPrice);
    if (addToCartBtnPriceEle) {
      addToCartBtnPriceEle.text("Rs." + totalPrice);
    }
    var app_product_template = $('body').data('template');

    if (app_product_template == 'product.subscription' || app_product_template == 'product.pan-india') {
      $('#AddToCartForm .deli-span').hide();
      $('#AddToCartForm .deli-span_value').hide();
    } else {
      $('#AddToCartForm .deli-span').show();
      $('#AddToCartForm .deli-span_value').show();
    }
  }
  $('#AddToCartForm .slot').on('change', function () {
    toggleTimePicker('#AddToCartForm');
    updateTotalPrice();
    cutoffTime();
  });
  function updateTotalPriceQv() {
    var app_product_template = $(".add-item-qv .app-pincode").data('template');
    let totalPrice = Number($('#quickViewModal .current-variant').data('variant_price'));
    totalPrice /= 100;
    let slotPrice = 0;

    if (app_product_template == 'product.subscription' || app_product_template == 'product.pan-india') {
      $('#quickViewModal .deli-span').hide();
      $('#quickViewModal .deli-span_value').hide();

    } else {
      $('#quickViewModal .deli-span').show();
      $('#quickViewModal .deli-span_value').show();
    }
    if (app_product_template != 'product.pan-india') {
      if ($('#quickViewModal .slot:checked').length > 0) {
        slotPrice = Number($('#quickViewModal .slot:checked').data('variant_price'));
      }
    }
    let addonPrice = 0;
    jQuery('#quickViewModal [name=app-addons]:checked').each(function () {
      let addon_price = jQuery(this).data('variant_price') || 0
      //totalPrice += Number(addon_price)/100;
      addonPrice += Number(addon_price) / 100;
    });
    var allExtras = slotPrice + addonPrice;
    var costExtras = jQuery("#quickViewModal .prod-cost__extras .prod-cost__value");
    var costAddon = jQuery("#quickViewModal .prod-cost__extras .prod-cost-addon__value");
    var costTotal = jQuery("#quickViewModal .prod-cost__total .prod-cost__value");

    totalPrice += allExtras;
    totalPrice = totalPrice.toLocaleString(undefined, { minimumFractionDigits: 2 });
    addonPrice = addonPrice.toLocaleString(undefined, { minimumFractionDigits: 2 });
    if (slotPrice > 0) {
      slotPrice = slotPrice.toLocaleString(undefined, { minimumFractionDigits: 2 });
    }

    if (app_product_template != 'product.pan-india' && app_product_template != 'product.subscription') {

      costExtras.show().text("Rs." + slotPrice);
    } else {
      costExtras.hide();
    }
    costAddon.text("Rs." + addonPrice);
    costTotal.text("Rs." + totalPrice);
  }
  $(document).on('change', '#quickViewModal .slot', function () {
    var type_slot = $(this).val();
    if (type_slot == 'standard') {
      $('#quickViewModal #prod-cost-block').hide();
    } else {
      $('#quickViewModal #prod-cost-block').show();
    }
    updateTotalPriceQv();
    cutoffTime();   // cutoffTime() rebuilds the real options and calls toggleTimePicker() itself
  });
  let zoomedOut = true; // start zoomed out
  let currentSlidesToShow = 3;
  let currentCardCount = 0;
  const $slider = $('#AddToCartForm .product-addons-dec-slider');

  // Determine slidesToShow based on screen width and zoom level
  function getSlidesToShow() {
    const width = window.innerWidth;
    if (width <= 400) {
      return zoomedOut ? 2 : 1;
    } else if (width <= 767) {
      return zoomedOut ? 3 : 2;
    } else if (width <= 992) {
      return zoomedOut ? 3 : 2;
    } else if (width <= 1370) {
      return zoomedOut ? 3 : 2;
    } else {
      return zoomedOut ? 4 : 3;
    }
  }
  function destroyslickSlider() {
    console.log('hello');
    if ($slider.hasClass('slick-initialized')) {
      $slider.slick('unslick');
      console.log('Quickview slider removed');
    }
  }
  function initializeSlider() {
    if ($slider.hasClass('slick-initialized')) {
      $slider.slick('unslick');
    }
    const slidesToShowDefault = zoomedOut ? 4 : 3;
    $slider.slick({
      infinite: false,
      slidesToShow: slidesToShowDefault,
      slidesToScroll: 1,
      centerPadding: '60px',
      prevArrow: '<span class="product-dec-icon product-dec-prev"><i class="fa fa-angle-left"></i></span>',
      nextArrow: '<span class="product-dec-icon product-dec-next"><i class="fa fa-angle-right"></i></span>',
      responsive: [
        {
          breakpoint: 1370,
          settings: {
            slidesToShow: zoomedOut ? 3 : 2,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: zoomedOut ? 3 : 2,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: zoomedOut ? 3 : 2,
            slidesToScroll: 1
          }
        }, {
          breakpoint: 400,
          settings: {
            slidesToShow: zoomedOut ? 2 : 1,
            slidesToScroll: 1
          }
        }
      ]
    });
  }

  $(document).ready(function () {
    const $addontabs = $('.main-product-form .type-tab');
    const $allProducts = $('.main-product-form #filtered-products .product-card').clone(); // Cache all products
    currentCardCount = $('.product-addons-dec-slider .product-card').length;

    // Hide tabs with no matching products
    $addontabs.each(function () {
      const tabType = $(this).data('type');

      const hasMatchingProduct = $allProducts.toArray().some(function (product) {
        const $product = $(product);
        return tabType === 'all' || $product.data('type') === tabType;
      });

      if (hasMatchingProduct) {
        $(this).show();
      } else {
        $(this).hide();
      }
    });

    $addontabs.on('click', function () {
      const selectedType = $(this).data('type');
      //$addontabs.removeClass('active');
      $(this).addClass('active');
      // Remove slick and clear container
      $('.main-product-form #filtered-products').slick('unslick');
      $('.main-product-form #filtered-products').empty();

      // Filter products by type and append to container
      const filteredProducts = $allProducts.filter(function () {
        const productType = $(this).data('type');
        return selectedType === 'all' || productType === selectedType;
      });

      $('.main-product-form #filtered-products').append(filteredProducts);
      currentCardCount = filteredProducts.length;

      // Tab active state
      $addontabs.removeClass('active');
      $(this).addClass('active');
    });

    $('.zoomToggleBtn').on('click', function () {
      if (zoomedOut) {
        // currentSlidesToShow = Math.max(1, currentSlidesToShow - 1);
        $(this).text('Zoom out').addClass('zoom-in').removeClass('zoom-out');
        $(this).parents().find('.product-addons-dec-slider').addClass('zoom-in-slider').removeClass('zoom-out-slider');
      } else {
        //currentSlidesToShow += 1;
        $(this).text('Zoom In').addClass('zoom-out').removeClass('zoom-in');
        $(this).parents().find('.product-addons-dec-slider').addClass('zoom-out-slider').removeClass('zoom-in-slider');
      }
      zoomedOut = !zoomedOut;
      if (currentCardCount > getSlidesToShow()) {
        initializeSlider();
      } else {
        destroyslickSlider();
      }

      //initializeSlider();

    });
  });
})(jQuery);

jQuery("#quickViewModal").on("shown.bs.modal", function (event) {
  allProductsQuickView = $('#quickViewModal #filtered-products .product-card').clone();
  $(this).find(".pincode-msg-check").show();
  $(this).find(".app-date-picker , .app-time-picker").hide();
});

jQuery("#quickViewModal").on("hidden.bs.modal", function (event) {
  const $modal = $(this);
  const $filteredContainer = $modal.find('#filtered-products');
  const allProductsqv = allProductsQuickView; // assuming it's cached on modal open

  if (!allProductsqv || !allProductsqv.length) return; // prevent errors if not cached

  if ($filteredContainer.hasClass('slick-initialized')) {
    $filteredContainer.slick('unslick');
  }

  $filteredContainer.empty().append(allProductsqv);

  const totalProducts = allProductsqv.length;
  // if ((window.innerWidth <= 768 && totalProducts > 2) || (window.innerWidth > 768 && totalProducts > 3)) {
  //     initializeQuickviewSlider();
  // }

  // 4. Reset tab state
  const $addontabsqv = $modal.find('.type-tab');
  $addontabsqv.removeClass('active');
  $addontabsqv.first().addClass('active');

  // 5. Reset tab scroll position
  const $tabWrapperqv = $modal.find('#type-tabs');
  $tabWrapperqv.scrollLeft(0);

  // updateArrowStateqv();


  $(".pincode-msg-check").hide();
  $(".app-date-picker , .app-time-picker , .app-form-location-msg").hide();
  // put your default event here
  $(" .app-pincode").val("");
  $('#quickViewModal #add-item-qv').trigger("reset");
  $('#quickViewModal #app-time-slot').css('display', 'none');
  $('#quickViewModal #app-time-picker').css('display', 'none');
  $('#quickViewModal .zoomToggleBtnQuickview').text('Zoom In').addClass('zoom-out').removeClass('zoom-in');
  $('#quickViewModal .zoomToggleBtnQuickview').parent().next().addClass('zoom-out-slider').removeClass('zoom-in-slider');

});

function isSameDate(date1, date2) {
  const d1 = new Date(date1);
  const d2 = new Date(date2);

  return (
    d1.getFullYear() === d2.getFullYear() &&
    d1.getMonth() === d2.getMonth() &&
    d1.getDate() === d2.getDate()
  );
}

function toggleTimePicker(formId) {
  if (
    $(formId + ' #slot-standard').is(':checked') ||
    $(formId + ' #slot-standar').is(':checked')
  ) {
    $(formId + ' .app-time-picker').hide();
  } else {
    $(formId + ' .app-time-picker').show();
  }
}

function getCityObjeForContext(product_id) {
  if ($('body').hasClass('modal-open')) {
    return Array.isArray(window.quickViewCityList) ? window.quickViewCityList : [];
  }
  return typeof Cityobje !== 'undefined' ? Cityobje : [];
}